<template>
    <div class="item"
         v-waypoint="{ active: true, callback: numbers, options: numbersIntersectionOptions }"
    >
        <span class="item__number" v-if="figure">
            <animate-number :ref="`myNum-${loopindex}`" :to="figure" from="0" mode="manual"></animate-number>
        </span>
        <span class="item__text" v-if="label">{{ label }}</span>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                didRun: false,
                numbersIntersectionOptions: {
                    root: null,
                    rootMargin: "0px 0px 0px 0px",
                    threshold: [0.6] // [0.25, 0.75] if you want a 25% offset!
                },
            }
        },
        props: {
            figure: {
                type: Number,
                default: 0
            },
            label: {
                type: String,
                default: ''
            },
            loopindex: {
                type: Number,
                default: 0
            }
        },
        methods: {
            numbers({going, direction}) {
                if (going === this.$waypointMap.GOING_IN) {
                    if (!this.didRun) {
                        const refname = `myNum-${this.loopindex}`;
                        this.$refs[refname].start();
                        this.didRun = true;
                    }
                }
            }
        },
    }
</script>